export const LABELS = {
  editMilestone: 'Edit',
  newMilestone: 'New milestone',
  newIssue: 'New issue',
  milestoneClosed: 'Closed ',
  milestoneOpen: 'Open',
  milestoneOverdue: 'Overdue by',
  separator: '•',
  milestoneLastUpdated: 'Last updated ',
  noDueDate: 'No due date',
  dueBy: 'Due by',
  milestoneError: 'Milestone cannot be loaded.',
  milestonesError: 'Milestones cannot be loaded.',
  milestoneErrorMessage: 'This milestone cannot be loaded due to a system error.',
  milestonesErrorMessage: 'Milestones cannot be loaded due to a system error.',
  milestoneIssuesError: 'Failed to load issues.',
  milestoneIssuesErrorMessage: "This milestone's issues can not be loaded due to a system error.",
  milestoneCreateError: 'Could not create milestone',
  milestonePageError: 'Could not load page',
  milestonePageErrorMessage: 'This page cannot be loaded due to a system error.',
  milestoneCreatePermissionError: 'You do not have permission to create milestones in this repository.',
  titleRequired: 'Title cannot be empty',
  bulkActions: 'Bulk actions',
  markAs: 'Mark as',
  label: 'Label',
  assign: 'Assign',
  project: 'Project',
  milestone: 'Milestone',
  noCreatedMilestones: 'You haven’t created any Milestones.',
  noCreatedMilestonesDescription:
    'Use Milestones to create collections of Issues and Pull Requests for a particular release or project.',
  createAMilestone: 'Create a milestone',
  weCouldntFindMilestones: 'We couldn’t find anything!',
  weCouldntFindMilestonesDescription: "There aren't any milestones that match. Give it another shot above.",
  milestones: 'Milestones',
  setIssueType: 'Issue type',
  numberOfResults: (numResults: number) => `${numResults} ${numResults === 1 ? 'result' : 'results'}`,
  emptyStateOpenIssues: 'There are no open issues in this milestone',
  emptyStateClosedIssues: 'There are no closed issues in this milestone',
  title: 'Title',
  description: 'Description (optional)',
  dueDate: 'Due date (optional)',
  createMilestone: 'Create milestone',
  cancel: 'Cancel',
  createMilestoneDescription: 'Create a new milestone to help organize your issues and pull requests. ',
  learnMorePrefix: 'Learn more about ',
  milestonesAndIssues: 'milestones and issues',
  datePlaceholder: 'Choose date...',
  titlePlaceholder: 'Milestone name',
  descriptionPlaceholder: 'Describe your milestone',
  saveChanges: 'Save changes',
  closeMilestone: 'Close milestone',
  reopenMilestone: 'Reopen milestone',
  editMilestoneTitle: 'Edit milestone',
  milestoneEditPermissionError: 'You do not have permission to edit milestones in this repository.',
  milestoneEditError: 'Could not edit milestone',
  deleteMilestoneConfirmationTitle: 'Permanently delete milestone',
  deleteMilestoneWarningPermanent: 'Once you delete this milestone you will not be able to see it again.',
  deleteMilestoneAssociatedIssuesNote: 'Deleting this milestone will not delete or close the associated issues.',
  deleteMilestoneConfirmationButton: 'Delete milestone',
  deleteMilestoneError: 'Could not delete this milestone. Please try again.',
  deleteMilestoneErrorAriaLabel: 'Error deleting milestone',
}
